<ng-container *ngIf="showAsCards">

  <ng-container *ngFor="let category of apiNavLinksCategories">

    <div style="padding: 16px;">
      <h2>{{category}}</h2>
      <mat-divider></mat-divider>
    </div>

    <ng-container *ngIf="apiNavLinksCategorized[category]">
    <mat-grid-list [cols]="columnCount" (window:resize)="onResize($event)" [rowHeight]="rowHeight" gutterSize="16">

      <mat-grid-tile *ngFor="let apiNavLink of apiNavLinksCategorized[category]">
        <app-api-link-card [apiNavLink]="apiNavLink" [allAPIsArePublic]="allAPIsArePublic"></app-api-link-card>
      </mat-grid-tile>
      <mat-grid-tile *ngIf="apiNavLinksCategorized[category].length % 2 != 0">
        &nbsp;
      </mat-grid-tile>
    </mat-grid-list>    
    </ng-container>
  </ng-container>

  <ng-container *ngIf="apiNavLinksOther.length">
    <div style="padding: 16px;">
      <h2>Other</h2>
      <mat-divider></mat-divider>
    </div>

    <mat-grid-list [cols]="columnCount" [rowHeight]="rowHeight" gutterSize="16">
      <mat-grid-tile *ngFor="let apiNavLink of apiNavLinksOther">
        <app-api-link-card [apiNavLink]="apiNavLink" [allAPIsArePublic]="allAPIsArePublic"></app-api-link-card>
      </mat-grid-tile>
    </mat-grid-list>
  </ng-container>

</ng-container>

<ng-container *ngIf="!showAsCards">
  <mat-nav-list>

    <ng-container *ngFor="let category of apiNavLinksCategories">
      <mat-list-item>
        <div>{{category}}</div>
      </mat-list-item>
      <ng-container *ngIf="apiNavLinksCategorized[category]">
      <mat-list-item *ngFor="let apiNavLink of apiNavLinksCategorized[category]" [routerLink]="['/dash','oapi-render', apiNavLink.name]">
        <a style="padding-left: 16px;" onclick="javascript:;">&mdash;{{apiNavLink.label}}</a>
        <div *ngIf="!allAPIsArePublic && apiNavLink.public" style="width: 8px; margin-left: 8px;" matBadge="P" matBadgeColor="primary" matTooltip="API is public" matTooltipPosition="right">
          &nbsp;
        </div>
      </mat-list-item>
      </ng-container>
      <mat-divider></mat-divider>
    </ng-container>

    <mat-list-item *ngFor="let apiNavLink of apiNavLinksOther" [routerLink]="['/dash','oapi-render', apiNavLink.name]">
      <a onclick="javascript:;">{{apiNavLink.label}}</a>
      <div *ngIf="!allAPIsArePublic && apiNavLink.public" style="width: 8px; margin-left: 8px;" matBadge="P" matBadgeColor="primary" matTooltip="API is public" matTooltipPosition="right">
        &nbsp;
      </div>
    </mat-list-item>

  </mat-nav-list>
</ng-container>

